export enum PermissionsRolesEnum {
  ADMIN = "admin",
  DASHBOARD_READ = "dashboard",
  SCHEDULE_READ = "schedule",
  SALES_READ = "sales",
  ORDERS_READ = "order-reading",
  ORDERS_WRITE = "order-writing",
  SUBSCRIPTIONS_WRITE = "subscriptions-writing",
  SUBSCRIPTIONS_READ = "subscriptions-reading",
  CUSTOMERS_READ = "customers-reading",
  CUSTOMERS_WRITE = "customers-writing",
}
